// extracted by mini-css-extract-plugin
export var btn_container = "index-module--btn_container--8e28d";
export var common_btn_container = "index-module--common_btn_container--1d891";
export var disable_btn_container = "index-module--disable_btn_container--7fd36";
export var disable_link = "index-module--disable_link--075f4";
export var medium_btn_container = "index-module--medium_btn_container--57b77";
export var small_btn_container = "index-module--small_btn_container--46749";